import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=68851b37&scoped=true&"
import script from "./companyDetails.vue?vue&type=script&lang=js&"
export * from "./companyDetails.vue?vue&type=script&lang=js&"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=68851b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68851b37",
  null
  
)

export default component.exports